<div class="teamViewFilters_container">
    <button mat-basic-button class="teamViewFilter_closeButton" (click)="close()"><mat-icon>close</mat-icon></button>

    <span class="teamViewFilter_header">{{filterHeader}}</span>
    <span class="teamViewFilter_actionSection">
        <mat-form-field *ngIf="orgListLoaded">
            <mat-label>{{"teamViewFilter.selectionLabel" | gender | translate}}</mat-label>
            <mat-select (selectionChange)="changeSelection($event.value)">
              <mat-option *ngFor="let currFilterOption of filterDataList" value="{{currFilterOption.value}}">{{currFilterOption.name}}</mat-option>
            </mat-select>
        </mat-form-field>
        <button mat-mini-fab color="primary" (click)="submit()"><mat-icon>send</mat-icon></button>
    </span>
</div>